import { gql } from '@apollo/client'

export const SUBSCRIBE = gql`
  mutation subscribe($userInput: userInput!) {
    subscribe(userInput: $userInput) {
      token
    }
  }
`

export const REACTIVATE_ORGANIZATION = gql`
  mutation reactivateOrganization($orgId: ID!, $planType: String!) {
    reactivateOrganization(orgId: $orgId, planType: $planType) {
      _id
      disabled
      delinquent
      subscriptions
    }
  }
`

export const DEALSAUCE_SUBSCRIBE = gql`
  mutation dealsauceSubscribe(
    $orgId: ID
    $email: String
    $priceId: String!
    $stripeToken: JSON
    $coupon: String
    $useExistingCard: Boolean
    $paymentMethodId: String
    $planType: String
  ) {
    dealsauceSubscribe(
      orgId: $orgId
      email: $email
      priceId: $priceId
      stripeToken: $stripeToken
      coupon: $coupon
      useExistingCard: $useExistingCard
      paymentMethodId: $paymentMethodId
      planType: $planType
    )
  }
`

export const GENERIC_SEND_EMAIL = gql`
  mutation genericSendEmail($msg: JSON!) {
    genericSendEmail(msg: $msg)
  }
`
